<template>
  <div
    class="documents-folder"
    :class="
      isEmpty && isFolder
        ? 'documents-folder--empty'
        : 'documents-folder--filled'
    "
  >
    <div v-if="isFolder">
      <div v-if="isEmpty">
        <sx-icon name="folderEmpty" :size="20" />
      </div>
      <div v-else>
        <sx-icon name="folder" :size="20" />
      </div>
    </div>
    <div v-else>
      <sx-icon name="file" :size="20" />
    </div>
  </div>
</template>

<script>
import SxIcon from '@/components/sx/SxIcon';
import SxFlex from '@/components/sx/SxFlex';

export default {
  components: {
    SxIcon,
    SxFlex,
  },
  props: {
    isFolder: {
      type: Boolean,
      required: false,
      default: false,
    },
    isEmpty: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
};
</script>

<style scoped>
.documents-folder {
  align-items: center;
  display: inline-flex;
  justify-content: center;

  height: 24px;
  min-width: 24px;
  width: 24px;
}

.documents-folder--filled {
  color: var(--blue-500);
}

.documents-folder--empty {
  color: var(--gray-500);
}
</style>
